module.exports = __webpack_public_path__ + "img/xitongweihu.b737d04d.png";